<template>
  <PageOne/>
  <PageTwo/>
  <PageThree/>
</template>

<script>
import PageOne from '@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/KashiCeramicSina/PageOne.vue';
import PageTwo from '@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/KashiCeramicSina/PageTwo.vue';
import PageThree from '@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/KashiCeramicSina/PageThree.vue';

export default {
  components: {
    PageOne,
    PageTwo,
    PageThree,
  },
  data() {
    return {}
  }
}
</script>
